export const CONVERSATION_STORAGE_KEY = 'agent-insights-conversation';

export const clearConversationFromStorage = () => {
  try {
    sessionStorage.removeItem(CONVERSATION_STORAGE_KEY);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Failed to clear conversation from session storage:', error);
  }
};
